import React, { useState } from 'react';
import { Switch, styled, Box, CircularProgress } from '@mui/material';

interface StyledSwitchProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const StyledSwitch = styled(({ checked, onChange, ...props }: StyledSwitchProps) => (
    <Switch checked={checked} onChange={onChange} {...props} />
))(({ theme }) => ({
    width: 48,
    height: 28,
    padding: 0,
    transform: 'rotate(180deg)', // <-- Rotate the entire switch
    '& .MuiSwitch-switchBase': {
        margin: 2,
        padding: 0,
        transform: 'translateX(20px)',
        '&.Mui-checked': {
            color: '#ffffff',
            transform: 'translateX(0px)',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
            border: '2px solid #ECEDEF',
        }, '&:not(.Mui-checked)': { // <-- Styles for when the switch is not checked
            color: '#9EACB4', // Assuming this is the desired light gray color for the thumb
            '& + .MuiSwitch-track': {
                backgroundColor: '#ECEDEF', // Background color for the track
                border: '1px solid #9EACB4',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 24,
        height: 24,
    },
    '& .MuiSwitch-track': {
        borderRadius: 24 / 2,
        border: '1px solid #bdbdbd',
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
}));



const CustomToggle: React.FC<{ checked: boolean, onChange: (event: React.ChangeEvent<HTMLInputElement>) => void }> = ({ checked, onChange }) => {
  const [loading, setLoading] = useState(false);

  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setLoading(true); // Start loading

      // Simulate a delay of 3 seconds
      setTimeout(() => {
          onChange(event); // Call the passed onChange function with the event
          setLoading(false); // Stop loading after the delay
      }, 1000);
  };  
  return (
        <Box>
            <Box display="flex" alignItems="center">
            {loading ? (
                <CircularProgress size={22} style={{ marginLeft: 10 }} /> // Loading indicator
            ) : (
                <StyledSwitch
                    checked={checked}
                    onChange={handleToggleChange}
                />
            )}
            </Box>
           
        </Box>
    );
};

export default CustomToggle;
